import { useState } from 'react';
import { Paper, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { GeneralTableBox, HeadTableCell, LoadingSkeleton, NoDataSkeleton, PaginationTable, RowTableCell } from '../../../common/components';
import { useNotificationJobRuns } from '../../../hooks/useNotifications';
import { formatDateTime, statusChip } from '../utils/notificationUtils';

export const JobRunsTable = () => {
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const { data, isLoading } = useNotificationJobRuns({
    target_app_module: 'habitat_99',
    page,
    per_page: rowsPerPage,
  });

  return (
    <>
      <Paper elevation={0}>
        <GeneralTableBox>
          <Table>
            <TableHead>
              <TableRow>
                <HeadTableCell>Regla</HeadTableCell>
                <HeadTableCell>Estado</HeadTableCell>
                <HeadTableCell>Modo</HeadTableCell>
                <HeadTableCell>Detectadas</HeadTableCell>
                <HeadTableCell>Generadas</HeadTableCell>
                <HeadTableCell>Detalle</HeadTableCell>
                <HeadTableCell>Inicio</HeadTableCell>
                <HeadTableCell>Fin</HeadTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {isLoading && (
                <TableRow>
                  <TableCell colSpan={8}>
                    <LoadingSkeleton />
                  </TableCell>
                </TableRow>
              )}
              {!isLoading && (data?.results || []).length === 0 && (
                <NoDataSkeleton colSpan={8} message="Todavía no hay ejecuciones registradas." />
              )}
              {(data?.results || []).map((job) => (
                <TableRow key={job.uuid} hover>
                  <RowTableCell>{job.rule_name || job.job_name}</RowTableCell>
                  <RowTableCell>{statusChip(job.status)}</RowTableCell>
                  <RowTableCell>{job.dry_run ? 'Dry-run' : 'Real'}</RowTableCell>
                  <RowTableCell>{job.detected_count}</RowTableCell>
                  <RowTableCell>{job.generated_count}</RowTableCell>
                  <RowTableCell sx={{ minWidth: 260 }}>
                    {job.error_message || job.summary?.message || '-'}
                  </RowTableCell>
                  <RowTableCell>{formatDateTime(job.started_at)}</RowTableCell>
                  <RowTableCell>{formatDateTime(job.finished_at)}</RowTableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </GeneralTableBox>
      </Paper>
      <PaginationTable
        totalPages={data?.total_pages || 1}
        totalCount={data?.total || 0}
        page={page}
        onPageChange={(_, value) => setPage(value)}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={(event) => {
          setRowsPerPage(Number(event.target.value));
          setPage(1);
        }}
      />
    </>
  );
};
